<div class="roadmaps-wysiwyg" [innerHTML]="cleanedRoadmaps | safe: 'html'" (click)="handleLinkClick($event)"></div>
